import { DialogNodeTypes } from '../../../../architecture/enums/DialogComponentType';
import { DialogBlock } from '../../../DialogBlocks/DialogBlock';
import { SingleQuestionNode } from '../SingleQuestionNode';

export class TextQuestionNode extends SingleQuestionNode {
  type: DialogNodeTypes = DialogNodeTypes.TextQuestionNode;
  constructor(block: DialogBlock) {
    super(block);

    this.title = 'Text Question Node';
  }
}
